import { render, staticRenderFns } from "./ApproveButton.vue?vue&type=template&id=24dca05a&"
import script from "./ApproveButton.vue?vue&type=script&lang=js&"
export * from "./ApproveButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports